/**
 * downloadRealm – create <realmID>.json on the fly and trigger a browser download
 *
 * @param {any}    payload  – the data to save (object, array, string…)
 * @param {string} realmID  – used as the filename (e.g. "Demo‑Realm‑001")
 */
export default function downloadRealm(payload, realmID = 'realm') {
    try {
      // 1) stringify with indentation for readability
      const json = JSON.stringify(payload, null, 2);
  
      // 2) turn it into a Blob and an object URL
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
  
      // 3) make a one‑shot hidden <a>, click it, clean up
      const a = document.createElement('a');
      a.href = url;
      a.download = `${sanitizeFileName(realmID)}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('❌ Failed to download realm JSON:', err);
    }
  }
  
  /* replace sketchy characters so the filename is OS‑safe */
  function sanitizeFileName(name) {
    return name.replace(/[^a-z0-9_\-\.]/gi, '_');
  }
  